export default __webpack_public_path__ + "static/media/room.dd200389.png";